import * as React from 'react'

function SvgNotiQuestionLine(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M12 2c5.522 0 10 4.477 10 10s-4.478 10-10 10S2 17.523 2 12 6.478 2 12 2zm0 2c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm0 11.6a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4zm.095-9.6C14.802 6 15.9 7.427 15.9 9.331c0 1.397-.774 2.17-1.888 2.988l-.48.357c-.417.312-.541.535-.541.758v.505c.013.364-.216.967-.99.967-.773 0-1.063-.5-1.036-.967v-.817c0-.595.263-1.13 1.083-1.695l.54-.372c.682-.461 1.347-.996 1.347-1.739 0-.907-.651-1.487-1.67-1.487-.96 0-1.64.401-1.765 1.442-.046.401-.416.795-.802.795-.96 0-1.161-.735-1.084-1.375C8.83 6.952 10.315 6 12.095 6z" />
    </svg>
  )
}

export default SvgNotiQuestionLine
